import EntityType from '@/shared/enums/EntityType';

export const EntityName = Object.freeze({
  [EntityType.ACTIVITY]: EntityType.ACTIVITY,
  [EntityType.ACTIVITY_PROPERTY]: 'ACTIVITY PROPERTY',
  [EntityType.ACTIVITY_PROPERTY_VALUE]: 'ACTIVITY PROPERTY VALUE',
  [EntityType.ACTIVITY_TAG]: 'ACTIVITY TAG',
  [EntityType.ACTIVITY_TAG_CATEGORY]: 'ACTIVITY TAG CATEGORY',
  [EntityType.ACTIVITY_TYPE]: 'ACTIVITY TYPE',
  [EntityType.DESIGN]: EntityType.ORGANISATION,
  [EntityType.GROUP]: 'TEAM',
  [EntityType.GROUP_PROPERTY]: 'TEAM PROPERTY',
  [EntityType.GROUP_PROPERTY_VALUE]: 'TEAM PROPERTY VALUE',
  [EntityType.GROUP_TAG]: 'TEAM TAG',
  [EntityType.GROUP_TAG_CATEGORY]: 'GROUP TAG CATEGORY',
  [EntityType.HISTORICAL]: 'HISTORICAL',
  [EntityType.L1_PROCESS]: 'PROCESS',
  [EntityType.LEAD]: 'TEAM LEAD',
  [EntityType.LIBRARY]: 'TYPE',
  [EntityType.LIVE]: EntityType.LIVE,
  [EntityType.MANAGER]: 'MANAGER',
  [EntityType.ORGANISATION]: EntityType.ORGANISATION,
  [EntityType.ROLE]: EntityType.ROLE,
  [EntityType.ROLE_PROPERTY]: 'ROLE PROPERTY',
  [EntityType.ROLE_PROPERTY_VALUE]: 'ROLE PROPERTY VALUE',
  [EntityType.ROLE_SKILL]: 'ROLE SKILL',
  [EntityType.ROLE_SKILL_LEVEL]: 'ROLE SKILL LEVEL',
  [EntityType.ROLE_TAG]: 'ROLE TAG',
  [EntityType.ROLE_TAG_CATEGORY]: 'ROLE TAG CATEGORY',
  [EntityType.ROLE_TYPE]: 'ROLE TYPE',
  [EntityType.SCENARIO]: 'SCENARIO',
  [EntityType.SKILL]: EntityType.SKILL,
  [EntityType.SKILL_LEVEL]: 'SKILL LEVEL',
  [EntityType.SPAN]: EntityType.SPAN,
  [EntityType.TAG]: EntityType.TAG,
  [EntityType.PERSON]: EntityType.PERSON,
  [EntityType.PERSON_SKILL]: 'PERSON SKILL',
  [EntityType.PERSON_SKILL_LEVEL]: 'PERSON SKILL LEVEL',
  [EntityType.PROPERTY]: EntityType.PROPERTY,
  [EntityType.SUPPORTER]: EntityType.SUPPORTER,
});

export const EntityPlural = Object.freeze({
  [EntityType.ACTIVITY]: 'ACTIVITIES',
  [EntityType.ACTIVITY_PROPERTY]: 'ACTIVITY PROPERTIES',
  [EntityType.ACTIVITY_PROPERTY_VALUE]: 'ACTIVITY PROPERTY VALUES',
  [EntityType.ACTIVITY_TAG]: 'ACTIVITY TAGS',
  [EntityType.ACTIVITY_TAG_CATEGORY]: 'ACTIVITY TAG CATEGORIES',
  [EntityType.ACTIVITY_TYPE]: 'ACTIVITY TYPES',
  [EntityType.DESIGN]: 'ORGANISATIONS',
  [EntityType.GROUP]: 'GROUPS',
  [EntityType.GROUP_PROPERTY]: 'GROUP PROPERTIES',
  [EntityType.GROUP_PROPERTY_VALUE]: 'GROUP PROPERTY VALUES',
  [EntityType.GROUP_TAG]: 'GROUP TAGS',
  [EntityType.GROUP_TAG_CATEGORY]: 'GROUP TAG CATEGORIES',
  [EntityType.HISTORICAL]: 'HISTORICAL',
  [EntityType.L1_PROCESS]: 'PROCESSES',
  [EntityType.LEAD]: 'TEAM LEADS',
  [EntityType.LIBRARY]: 'TYPES',
  [EntityType.LIVE]: 'LIVE',
  [EntityType.MANAGER]: 'MANAGERS',
  [EntityType.ORGANISATION]: 'ORGANISATIONS',
  [EntityType.ROLE]: 'ROLES',
  [EntityType.ROLE_PROPERTY]: 'ROLE PROPERTIES',
  [EntityType.ROLE_PROPERTY_VALUES]: 'ROLE PROPERTY VALUES',
  [EntityType.ROLE_SKILL]: 'ROLE SKILLS',
  [EntityType.ROLE_SKILL_LEVEL]: 'ROLE SKILL LEVELS',
  [EntityType.ROLE_TAGS]: 'ROLE TAGS',
  [EntityType.ROLE_TAG_CATEGORY]: 'ROLE TAG CATEGORIES',
  [EntityType.ROLE_TYPE]: 'ROLE TYPES',
  [EntityType.SCENARIO]: 'SCENARIOS',
  [EntityType.SKILL]: 'SKILLS',
  [EntityType.SKILL_LEVEL]: 'SKILL LEVELS',
  [EntityType.SPAN]: 'SPANS',
  [EntityType.TAG]: 'TAGS',
  [EntityType.PERSON]: 'PEOPLE',
  [EntityType.PERSON_SKILL]: 'PEOPLE SKILLS',
  [EntityType.PERSON_SKILL_LEVEL]: 'PEOPLE SKILL LEVELS',
  [EntityType.PROPERTY]: 'PROPERTIES',
  [EntityType.SUPPORTER]: 'SUPPORTERS',
});

export const EntityPluralName = Object.freeze({
  [EntityType.ACTIVITY]: 'Activities',
  [EntityType.ACTIVITY_PROPERTY]: 'Activity properties',
  [EntityType.ACTIVITY_PROPERTY_VALUE]: 'Activity property values',
  [EntityType.ACTIVITY_TAG]: 'Activity tags',
  [EntityType.ACTIVITY_TAG_CATEGORY]: 'Activity tag categories',
  [EntityType.ACTIVITY_TYPE]: 'Activity types',
  [EntityType.DESIGN]: 'Organisations',
  [EntityType.GROUP]: 'Teams',
  [EntityType.GROUP_PROPERTY]: 'Team properties',
  [EntityType.GROUP_PROPERTY_VALUE]: 'Team property values',
  [EntityType.GROUP_TAG]: 'Team tags',
  [EntityType.GROUP_TAG_CATEGORY]: 'Group tag categories',
  [EntityType.HISTORICAL]: 'Historical',
  [EntityType.L1_PROCESS]: 'Processes',
  [EntityType.LEAD]: 'Leads',
  [EntityType.LIBRARY]: 'Types',
  [EntityType.LIVE]: 'Live',
  [EntityType.MANAGER]: 'Managers',
  [EntityType.ORGANISATION]: 'Organisations',
  [EntityType.ROLE]: 'Roles',
  [EntityType.ROLE_PROPERTY]: 'Role properties',
  [EntityType.ROLE_PROPERTY_VALUE]: 'Role property values',
  [EntityType.ROLE_SKILL]: 'Role skills',
  [EntityType.ROLE_SKILL_LEVEL]: 'Role skill levels',
  [EntityType.ROLE_TAG]: 'Role tags',
  [EntityType.ROLE_TAG_CATEGORY]: 'Role tag categories',
  [EntityType.ROLE_TYPE]: 'Role types',
  [EntityType.SCENARIO]: 'Scenarios',
  [EntityType.SKILL]: 'Skills',
  [EntityType.SKILL_LEVEL]: 'Skill levels',
  [EntityType.SPAN]: 'Spans',
  [EntityType.TAG]: 'Tags',
  [EntityType.PERSON]: 'People',
  [EntityType.PERSON_SKILL]: 'People skills',
  [EntityType.PERSON_SKILL_LEVEL]: 'People skill levels',
  [EntityType.PROPERTY]: 'Properties',
  [EntityType.PROPERTY_VALUE]: 'Property values',
  [EntityType.SUPPORTER]: 'Supporters',
});

export const EntityPluralLower = Object.freeze({
  [EntityType.ACTIVITY]: EntityPlural[EntityType.ACTIVITY].toLowerCase(),
  [EntityType.ROLE]: EntityPlural[EntityType.ROLE].toLowerCase(),
  [EntityType.GROUP]: EntityPlural[EntityType.GROUP].toLowerCase(),
  [EntityType.PERSON]: EntityPlural[EntityType.PERSON].toLowerCase(),
});

export default EntityName;
